const recordCountPerPage = 7;

export default recordCountPerPage;
